export default (axios) => ({
    create: (data) => axios.post('u/consultations?origin=benhvien16a.com', data).then((_) => _.data),
});
